import { normalizeTimesheetStatus } from "@/pages/stundennachweise/timesheetFilterLogic";
import type { TimesheetSummary } from "@/lib/timesheets";

export interface TimesheetProjectCloseContext {
  auftragId: number;
  baseTimesheetId?: number | null;
}

function getRevisionBaseKey(ts: Pick<TimesheetSummary, "base_timesheet_id" | "id">): string {
  return String(ts.base_timesheet_id ?? ts.id ?? "");
}

/** Entspricht `getStatus()` auf der klassischen Stundennachweis-Seite. */
function getBlockingTimesheetStatus(ts: TimesheetSummary): string {
  return normalizeTimesheetStatus(ts.status_display || ts.status || "draft");
}

export function hasBlockingSiblingTimesheetForProject(
  timesheetId: number,
  timesheets: TimesheetSummary[],
  context?: TimesheetProjectCloseContext,
): boolean {
  const currentId = String(timesheetId);
  const current = timesheets.find((ts) => String(ts.id) === currentId);
  const auftragId = current?.auftrag_id ?? context?.auftragId;
  if (!auftragId) return false;

  const currentBaseId = current
    ? getRevisionBaseKey(current)
    : String(context?.baseTimesheetId ?? timesheetId);

  // Only Entwurf blocks project close. Geschrieben (ready) and later statuses do not.
  const blockingStatuses = new Set(["draft"]);

  return timesheets.some((ts) => {
    if (!ts || String(ts.id) === currentId) return false;
    if (String(ts.auftrag_id) !== String(auftragId)) return false;
    if (getRevisionBaseKey(ts) === currentBaseId) return false;
    if (ts.has_newer_revision === true) return false;
    return blockingStatuses.has(getBlockingTimesheetStatus(ts));
  });
}

export function isMobileDevice(): boolean {
  if (typeof window === "undefined") return false;
  const ua = navigator.userAgent || "";
  return (
    /Mobi|Android/i.test(ua) ||
    (window.matchMedia != null && window.matchMedia("(max-width: 768px)").matches)
  );
}

export function projectCloseConflictMessage(status?: number): string {
  if (status === 409) {
    return "Projekt konnte nicht abgeschlossen werden: Es gibt weitere Stundennachweise im Status Entwurf zu diesem Projekt. Bitte schließe diese zuerst ab.";
  }
  return "Projekt konnte nicht abgeschlossen werden.";
}
